import React from "react";
import UiContext from "../../context/UiContext";
import Modal from "../Modal";

import { AddPinModal } from "./AddPinModal";
import { AllEntriesModal } from "./AllEntriesModal";

const ModalController: React.FC = () => {
  const { state, closeModal } = React.useContext(UiContext);

  return (
    <Modal
      name={state.modal.name || ""}
      isOpen={state.modal.isOpen}
      showClose={state.modal.showClose}
      isFullPage={state.modal.isFullPage}
      disableFocusTrap={state.dialog.isOpen}
      onClose={closeModal}
    >
      {/* Dynamic loading */}
      <>{state.modal?.name === "addPin" && <AddPinModal />}</>
      <>{state.modal?.name === "entries" && <AllEntriesModal />}</>
    </Modal>
  );
};

export default ModalController;
